<script>
import axios from 'axios'
import optionsData from '../../assets/options/options.json'

export default {
  name: 'SplideComponent',
  data() {
    return {
      slides: null,
      options: null,
      currentMonth: new Date().getMonth() + 1,
      currentYear: new Date().getFullYear(),
      errorMessage: null
    }
  },
  methods: {
    getSlidesData() {
      axios
        .get(`/api/v1/eventi?m=` + this.currentMonth + '&Y=' + this.currentYear)
        .then((response) => {
          if (response.status === 200 && response.statusText === 'OK') {
            if (response.data.data.length > 0) {
              this.errorMessage = null
              this.slides = response.data
              this.setSplideOptions()
            } else {
              this.slides = response.data
              this.errorMessage = response.data.error_message
            }
          }
        })
    },
    setSplideOptions() {
      this.options = optionsData
    },
    goToPreviousMonth() {
      if (this.currentMonth > 1) {
        this.currentMonth = this.currentMonth - 1
      } else {
        this.currentMonth = 12
        this.currentYear = this.currentYear - 1
      }
      this.getSlidesData()
    },
    goToNextMonth() {
      if (this.currentMonth < 12) {
        this.currentMonth = this.currentMonth + 1
      } else {
        this.currentMonth = 1
        this.currentYear = this.currentYear + 1
      }
      this.getSlidesData()
    }
  },
  mounted() {
    this.getSlidesData()
  }
}
</script>

<template>
  <div v-if="slides">
    <div class="card-header text-center bg-primary custom-card-header-border-radius d-flex align-items-center justify-content-center">
      <button class="btn" type="button" @click="goToPreviousMonth()">&lt;</button>
      <label class="fs-6 text-white fw-bold m-0 py-1">{{
        slides.month.label + ' ' + slides.Year
      }}</label>
      <button class="btn" type="button" @click="goToNextMonth()">></button>
    </div>
    <div v-if="errorMessage" class="text-center p-2">
      {{ errorMessage }}
    </div>
  </div>
  <Splide aria-labelledby="basic-example-heading" :options="options" v-if="slides">
    <SplideSlide v-for="slide in slides.data" :key="slide.alt">
      <div
        class="card rounded-0 mb-5 border-0 custom-card-shadows"
        style="box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <div class="border-bottom border-1 pb-3" style="border-color: #c5c7c9 !important">
                <h1 style="color: #5b6f82">{{ slide.d }}</h1>
                <span style="color: #5b6f82" class="ps-2 ms-1">{{ slide.D }}</span>
              </div>
            </div>
            <div
              class="col-12"
              v-for="(item, index) in slide.items"
              :key="index"

            >
              <div v-html="item.html"></div>
            </div>
          </div>
        </div>
      </div>
    </SplideSlide>
  </Splide>
</template>

<style scoped>
.custom-card-header-border-radius {
  border-radius: 4px 4px 0px 0px;
}
</style>
